import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FilterModelDto} from "../../models/filter.model";
import {FilterSettingService} from "../../services/filter-setting.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.scss']
})
export class FilterInputComponent implements OnInit, OnDestroy {

  @Input() filter!: FilterModelDto
  filterValue = ''
  subs: Subscription[] = []

  constructor(
    private filterSettingService: FilterSettingService
  ) {
  }

  ngOnInit() {
    this.resetListener()
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe())
  }

  setSum() {
    const filterData: FilterModelDto = {
      fieldName: this.filter.fieldName,
      value: this.filterValue,
      description: this.filterValue
    }
    this.filterSettingService.filterSet$.next(filterData)

    if (!this.filterValue) {
      this.filterSettingService.filterItemReset$.next(filterData)
    }
  }

  resetListener() {
    this.subs.push(this.filterSettingService.filterItemReset$.subscribe({
      next: (res) => {
        if (this.filter.fieldName === res.fieldName) {
          this.filterValue = ''
        }
      }
    }))

    this.subs.push(this.filterSettingService.filterAllReset$.subscribe({
      next: () => {
        this.filterValue = ''
      }
    }))
  }

}
